const detectDiryFields = (dirtyFields, index) => {
  try {
    if (dirtyFields.items[index]) {
      const keys = Object.keys(dirtyFields.items[index]);

      for (const element of keys) {
        if (
          dirtyFields.items[index][element] === true &&
          element !== "price" &&
          element !== "ui"
        )
          return true;
      }
    }

    return false;
  } catch (error) {
    return false;
  }
};

export default detectDiryFields;
